import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4ad5ba14")

_pushScopeId("data-v-4ad5ba14")
const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "relative lg:w-5/12 w-full h-screen flex flex-col justify-between bg-white" }
const _hoisted_3 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_4 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4" }
const _hoisted_6 = { class: "px-8 py-4 overflow-auto h-screen pb-32" }
const _hoisted_7 = { class: "text-12px xxl:text-14px text-gray-lp-500" }
const _hoisted_8 = { class: "flex flex-col my-4" }
const _hoisted_9 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_10 = { class: "flex flex-col my-4" }
const _hoisted_11 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = { class: "flex flex-row items-center" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_16 = { class: "mt-2 w-36" }
const _hoisted_17 = { class: "w-full z-20 absolute bottom-0 items-center flex flex-row rounded-b-md text-xs bg-gray-lp-700 justify-end px-8 py-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none", { 'pb-4': _ctx.isShowRunningText }]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("manualStt.generateTitle")), 1),
              _createVNode("img", {
                src: _imports_0,
                class: "w-4 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                alt: ""
              })
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("manualStt.generateInfo")), 1),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("manualStt.labelTypeStt")), 1),
              _createVNode(_component_Select, {
                "is-disabled": 
                  _ctx.getAccount.accountType !== 'internal' &&
                    _ctx.getAccount.accountType !== 'partner'
                ,
                dataSelect: _ctx.typeSTT,
                onOpenSelect: _ctx.onOpenTypeSelect,
                onCloseSelect: _ctx.onCloseTypeSelect,
                onChooseSelect: _ctx.onSelectType,
                value: _ctx.typeName,
                isOpenMenu: _ctx.typeSelect,
                class: "text-12px xxl:text-14px my-2 z-20 w-full"
              }, null, 8, ["is-disabled", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("manualStt.labelClientPartner")), 1),
              _createVNode("div", _hoisted_12, [
                (_ctx.isClientParent)
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      onFilter: _ctx.onSearchClientName,
                      isLoading: _ctx.isLoadingClientPartner,
                      options: _ctx.mappedDataClient,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('manualStt.placeholderClientBranch'),
                      modelValue: _ctx.clientValue,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.clientValue = $event))
                    }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue"]))
                  : (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 1,
                      "is-disabled": 
                    _ctx.getAccount.accountType !== 'internal' ||
                      _ctx.getAccount.accountType !== 'partner'
                  ,
                      onFilter: _ctx.fetchClientPartner,
                      isLoading: _ctx.isLoadingClientPartner,
                      options: _ctx.clientPartnerData,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('manualStt.placeholderClientPartner'),
                      modelValue: _ctx.clientValue,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.clientValue = $event)),
                      isDisabled: _ctx.isTypeSttSelected
                    }, null, 8, ["is-disabled", "onFilter", "isLoading", "options", "placeholder", "modelValue", "isDisabled"]))
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("manualStt.labelAmountStt")), 1),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_lp_input, {
                    type: "number",
                    modelValue: _ctx.amountSTT,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.amountSTT = $event)),
                    placeholder: _ctx.$t('manualStt.placeholderAmount'),
                    error: _ctx.amountSTT > _ctx.maxGenerateManualSTT,
                    errorCaption: 
                      _ctx.$t('manualStt.validationAmountMax', {
                        max: _ctx.maxGenerateManualSTT
                      })
                    
                  }, null, 8, ["modelValue", "placeholder", "error", "errorCaption"])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_button_outline, {
            custom: "bg-white px-12 border border-red-lp-100 text-red-lp-200 mr-4",
            title: _ctx.$t('manualStt.buttonBack'),
            onClick: _ctx.onClose
          }, null, 8, ["title", "onClick"]),
          _createVNode(_component_button_fill, {
            custom: "px-12 bg-red-lp-200",
            title: _ctx.$t('manualStt.buttonAutoGenerate'),
            isLoading: _ctx.isLoading,
            isDisabled: _ctx.isDisabled,
            onClick: _ctx._onAdd
          }, null, 8, ["title", "isLoading", "isDisabled", "onClick"])
        ])
      ])
    ], 2),
    _hoisted_18
  ]))
})